import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-health",
  templateUrl: "./med-icon-health.component.html",
})
export class MedIconHealthComponent extends SvgMixinComponent {}
